var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keypoint",on:{"click":function($event){return _vm.$emit('click')}}},[_c('transition',{attrs:{"name":"t-fader__enter-delay"}},[(!_vm.isSelected)?_c('div',{staticClass:"keypoint__bullet"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }